<template>
  <select class="form-control font-weight-bold " v-model="valor" @change="$emit('evento', valor)">
     <option v-if="todo" value="Todo">Todo</option>
     <option v-if="todo==undefined" value="">Seleccione</option>
     <option value="1">Enero</option>
     <option value="2">Febrero</option>
     <option value="3">Marzo</option>
     <option value="4">Abril</option>
     <option value="5">Mayo</option>
     <option value="6">Junio</option>
     <option value="7">Julio</option>
     <option value="8">Agosto</option>
     <option value="9">Septiembre</option>
     <option value="10">Octubre</option>
     <option value="11">Noviembre</option>
     <option value="12">Diciembre</option>
   </select>
</template>

<script>
export default {
    name:"mesesComponent",
      props: ['valor_entrada','todo'],
    	data() {
			return {
				anios: [],
                valor: '',
			}
		},
        created(){
             setTimeout(() => {
                this.valor = this.valor_entrada;
            }, 100);
           
           
        },
   
}
</script>

